/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import {
  FiMail,
  FiUser,
  FiPhone,
  FiCreditCard,
  FiDollarSign,
  FiPackage,
  FiBriefcase,
  FiBookmark,
  FiCalendar,
  FiThermometer,
  FiMessageSquare,
  FiActivity,
  FiEdit,
  FiShare2,
  FiPaperclip,
  FiMessageCircle,
  FiMinimize
} from 'react-icons/fi';
import BaseForm from '../../app/components/BaseForm';
import Input from '../../app/components/Input';
import Button from '../../app/components/Button';
import Accordion from '../../app/components/Accordion';

const CardDetailForm = ({ isOpen, onClose, cardData, updateCard }) => {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    cnpj: '',
    razaoSocial: '',
    nomeFantasia: '',
    fase: '',
    observacoes: '',
    anexos: [],
    value: '',
    service: '',
    dataFechamento: '',
    temperatura: '',
  });

  const [editField, setEditField] = useState(null);
  const [tempValue, setTempValue] = useState('');
  const [accordionSections, setAccordionSections] = useState([]);
  const [fasesExpanded, setFasesExpanded] = useState({});

  const movimentacoes = [
    { id: 1, data: '10/07/2025', descricao: 'Mudança de fase: Negociação → Contrato Assinado', autor: 'Ana Célia' },
    { id: 2, data: '05/07/2025', descricao: 'Adicionado novo documento: Proposta.pdf', autor: 'João Silva' },
  ];

  const alteracoes = [
    { id: 1, data: '10/07/2025', campo: 'Valor da Venda', valorAntigo: 'R$ 5.000,00', valorNovo: 'R$ 7.500,00', autor: 'Ana Célia' },
    { id: 2, data: '07/07/2025', campo: 'Temperatura do Negócio', valorAntigo: 'Morno', valorNovo: 'Quente', autor: 'João Silva' },
    { id: 3, data: '01/07/2025', campo: 'Email', valorAntigo: 'contato@empresa.com', valorNovo: 'financeiro@empresa.com', autor: 'Ana Célia' },
  ];

  const fases = [
    'Lead quente',
    'Negociação',
    'Abertura vendida',
    'Ganho (falta contrato)',
    'Contrato Assinado',
    'Arquivo',
    'Perdido',
    'Não Convertido',
  ];

  useEffect(() => {
    if (cardData) {
      console.log("Card data recebido:", cardData);
      setFormData({
        nome: cardData.client || '',
        email: cardData.email || '',
        telefone: cardData.telefone || '',
        cnpj: cardData.cnpj || '',
        razaoSocial: cardData.razaoSocial || cardData.client || '',
        nomeFantasia: cardData.nomeFantasia || '',
        fase: getFaseFromCardColumn(cardData.columnId) || 'Negociação',
        observacoes: cardData.observacoes || '',
        anexos: cardData.anexos || [],
        value: cardData.value || '',
        service: cardData.service || '',
        dataFechamento: cardData.dataFechamento || '',
        temperatura: cardData.temperatura || '',
      });
    }
  }, [cardData]);

  useEffect(() => {
    const movimentacoesItems = movimentacoes.map((mov) => (
      <div key={mov.id} className="border-b pb-2 last:border-b-0 last:pb-0">
        <div className="flex justify-between">
          <span className="text-sm font-medium">{mov.descricao}</span>
          <span className="text-xs text-gray-500">{mov.data}</span>
        </div>
        <div className="text-xs text-gray-500 font-medium mt-2">Por: {mov.autor}</div>
      </div>
    ));

    const alteracoesItems = alteracoes.map((alt) => (
      <div key={alt.id} className="border-b pb-2 last:border-b-0 last:pb-0">
        <div className="flex justify-between">
          <span className="text-sm font-medium">Campo: {alt.campo}</span>
          <span className="text-xs text-gray-500">{alt.data}</span>
        </div>
        <div className="text-xs">
          <span className="line-through text-red-500">{alt.valorAntigo}</span>
          {' → '}
          <span className="text-green-600">{alt.valorNovo}</span>
        </div>
        <div className="text-xs text-gray-500 font-medium mt-2">Por: {alt.autor}</div>
      </div>
    ));

    setAccordionSections([
      {
        id: 'movimentacoes',
        title: 'Ver Movimentações',
        icon: <FiActivity className="w-4 h-4 text-gray-500" />,
        count: movimentacoes.length,
        expanded: false,
        items: movimentacoesItems
      },
      {
        id: 'alteracoes',
        title: 'Ver Alterações',
        icon: <FiEdit className="w-4 h-4 text-gray-500" />,
        count: alteracoes.length,
        expanded: false,
        items: alteracoesItems
      },
      {
        id: 'comentarios',
        title: 'Ver Comentários',
        icon: <FiMessageCircle className="w-4 h-4 text-gray-500" />,
        count: alteracoes.length,
        expanded: false,
        items: alteracoesItems
      }
    ]);

    const initialFasesState = {};
    fases.forEach((fase, index) => {
      initialFasesState[index] = false; 
    });
    setFasesExpanded(initialFasesState);
  }, [formData.fase]);

  const getFaseFromCardColumn = (columnId) => {
    const columnToFaseMap = {
      negotiation: 'Negociação',
      toPay: 'A pagar',
      paid: 'Pagos',
      waitingForDocuments: 'Aguardando documentos',
      completed: 'Concluídos',
    };
    return columnToFaseMap[columnId] || 'Negociação';
  };

  const handleFieldClick = (fieldName) => {
    setEditField(fieldName);
    setTempValue(formData[fieldName] || '');
  };

  const handleFieldSave = (fieldName) => {
    setFormData((prev) => ({ ...prev, [fieldName]: tempValue }));
    setEditField(null);
  };

  const handleFieldCancel = () => {
    setEditField(null);
  };

  const handleChange = (e) => {
    const { value } = e.target;
    setTempValue(value);
  };

  const handleFileChange = (files) => {
    const fileArray = Array.from(files).map(file => ({
      name: file.name,
      size: file.size,
      type: file.type,
      lastModified: file.lastModified
    }));
    
    setTempValue(JSON.stringify(fileArray));
  };

  const handleSubmit = () => {
    if (!cardData) return;

    const updatedCard = {
      ...cardData,
      client: formData.nome,
      email: formData.email,
      telefone: formData.telefone,
      cnpj: formData.cnpj,
      razaoSocial: formData.razaoSocial,
      nomeFantasia: formData.nomeFantasia,
      observacoes: formData.observacoes,
      anexos: formData.anexos,
      value: formData.value,
      service: formData.service,
      dataFechamento: formData.dataFechamento,
      temperatura: formData.temperatura,
      hasEmail: !!formData.email,
      hasFile: formData.anexos?.length > 0,
      fileCount: formData.anexos?.length || undefined,
      hasObservacoes: !!formData.observacoes,
      lastUpdate: '1d',
    };

    if (formData.email !== cardData.email || formData.telefone !== cardData.telefone) {
      updatedCard.messageCount = (cardData.messageCount || 0) + 1;
    }

    updateCard(updatedCard);
    onClose();
  };

  const handleToggleSection = (sectionId) => {
    setAccordionSections(prev => 
      prev.map(section => 
        section.id === sectionId 
          ? { ...section, expanded: !section.expanded }
          : section
      )
    );
  };

  const handleToggleFase = (faseIndex) => {
    setFasesExpanded(prev => ({
      ...prev,
      [faseIndex]: !prev[faseIndex]
    }));
  };

  const renderEditableField = (label, icon, fieldName, subtitle) => (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {icon}
        {label}
      </label>
      {subtitle && <div className="text-xs text-gray-500 mb-1">{subtitle}</div>}

      {editField === fieldName ? (
        <>
          <Input
            name={fieldName}
            value={tempValue}
            onChange={handleChange}
            className="mb-2"
          />
          <div className="flex gap-2">
            <Button
              variant="primary"
              size="sm"
              onClick={() => handleFieldSave(fieldName)}
            >
              Salvar
            </Button>
            <Button variant="secondary" size="sm" onClick={handleFieldCancel}>
              Cancelar
            </Button>
          </div>
        </>
      ) : (
        <div
          className="font-normal mt-2 text-sm cursor-pointer text-gray-400 transition-colors duration-300 hover:text-gray-500"
          onClick={() => handleFieldClick(fieldName)}
        >
          {formData[fieldName] || 'Clique aqui para editar'}
        </div>
      )}
    </div>
  );

  if (!cardData) return null;

  return (
    <BaseForm
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      title={formData.nome || 'Detalhes do Cliente'}
      primaryColor="#7e22ce"
      actions={
        <>
          <Button variant="secondary" onClick={onClose}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Salvar Alterações
          </Button>
        </>
      }
      className="max-w-[1536px] !p-0 !max-h-[96vh]"
    >
      <div className="flex min-h-[600px]">
        <div className="w-1/3 border-r p-6" style={{ maxHeight: '80vh' }}>
          <div className="flex items-center mb-4">
            <img
              src={`https://ui-avatars.com/api/?name=${encodeURIComponent(formData.nome || 'User')}&background=random`}
              className="w-12 h-12 rounded-full mr-4"
              alt="Avatar"
            />
            <div>
              <div className="text-sm text-gray-600">Criado por:</div>
              <div className="font-medium flex items-center">
                Ana Célia
              </div>
            </div>
          </div>

          <div className="border-t pt-4">
            <h3 className="font-semibold mb-2">Formulário Inicial</h3>
            {renderEditableField('Nome do Cliente', <FiUser className="inline mr-2" size={16} />, 'nome', 'Obrigatório para gerar Proposta.')}
            {renderEditableField('Email', <FiMail className="inline mr-2" size={16} />, 'email')}
            {renderEditableField('Telefone', <FiPhone className="inline mr-2" size={16} />, 'telefone')}
            {renderEditableField('CNPJ', <FiCreditCard className="inline mr-2" size={16} />, 'cnpj')}
            {renderEditableField('Valor da Venda', <FiDollarSign className="inline mr-2" size={16} />, 'value')}
            {renderEditableField('Produto/Serviço', <FiPackage className="inline mr-2" size={16} />, 'service')}
            {renderEditableField('Razão Social', <FiBriefcase className="inline mr-2" size={16} />, 'razaoSocial')}
            {renderEditableField('Nome Fantasia', <FiBookmark className="inline mr-2" size={16} />, 'nomeFantasia')}
          </div>
        </div>

        <div className="w-1/3 p-6 overflow-y-auto" style={{ maxHeight: '80vh' }}>
          <div className="w-full">
            <div className="flex justify-between items-center mb-4">
              <h3 className="font-semibold">Formulário da fase</h3>
              <button className="text-purple-700 flex items-center text-xs font-medium">
                <FiShare2 className="w-4 h-4 mr-1" />
                Compartilhar Formulário da Fase
              </button>
            </div>

            <div className="border-t border-gray-200 pt-4">
              <div className="mb-5">
                <div className="flex items-center mb-1">
                  <FiCalendar className="inline mr-2" size={16} />
                  <label className="text-sm font-medium text-gray-700">Data do fechamento esperado</label>
                </div>
                <div className="text-xs text-gray-500 mb-1">Obrigatório para gerar Proposta.</div>
                {editField === 'dataFechamento' ? (
                  <>
                    <Input
                      name="dataFechamento"
                      value={tempValue}
                      onChange={handleChange}
                      className="mb-2"
                    />
                    <div className="flex gap-2">
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={() => handleFieldSave('dataFechamento')}
                      >
                        Salvar
                      </Button>
                      <Button variant="secondary" size="sm" onClick={handleFieldCancel}>
                        Cancelar
                      </Button>
                    </div>
                  </>
                ) : (
                  <div
                    className="font-normal mt-2 text-sm cursor-pointer text-gray-400 transition-colors duration-300 hover:text-gray-500"
                    onClick={() => handleFieldClick('dataFechamento')}
                  >
                    {formData.dataFechamento || 'Clique aqui para editar'}
                  </div>
                )}
              </div>
              
              <div className="mb-5">
                <div className="flex items-center mb-1">
                  <FiThermometer className="inline mr-2" size={16} />
                  <label className="text-sm font-medium text-gray-700">Temperatura do Negócio</label>
                </div>
                {editField === 'temperatura' ? (
                  <>
                    <Input
                      name="temperatura"
                      value={tempValue}
                      onChange={handleChange}
                      className="mb-2"
                    />
                    <div className="flex gap-2">
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={() => handleFieldSave('temperatura')}
                      >
                        Salvar
                      </Button>
                      <Button variant="secondary" size="sm" onClick={handleFieldCancel}>
                        Cancelar
                      </Button>
                    </div>
                  </>
                ) : (
                  <div
                    className="font-normal mt-2 text-sm cursor-pointer text-gray-400 transition-colors duration-300 hover:text-gray-500"
                    onClick={() => handleFieldClick('temperatura')}
                  >
                    {formData.temperatura || 'Clique aqui para editar'}
                  </div>
                )}
              </div>
              
              {/* Anexos */}
              <div className="mb-5">
                <div className="flex items-center mb-1">
                  <FiPaperclip className="inline mr-2" size={16} />
                  <label className="text-sm font-medium text-gray-700">Anexos:</label>
                </div>
                {editField === 'anexos' ? (
                  <>
                    <div className="mb-2 flex items-center">
                      <Input
                        type="file"
                        name="anexos"
                        onChange={(e) => {
                          handleFileChange(e.target.files);
                        }}
                        className="flex-1"
                        multiple
                      />
                    </div>
                    <div className="flex gap-2">
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={() => handleFieldSave('anexos')}
                      >
                        Salvar
                      </Button>
                      <Button variant="secondary" size="sm" onClick={handleFieldCancel}>
                        Cancelar
                      </Button>
                    </div>
                  </>
                ) : (
                  <div
                    className="font-normal mt-2 text-sm cursor-pointer text-gray-400 transition-colors duration-300 hover:text-gray-500"
                    onClick={() => handleFieldClick('anexos')}
                  >
                    {formData.anexos && formData.anexos.length > 0 
                      ? (
                        <div className="text-gray-700">
                          {formData.anexos.map((anexo, index) => (
                            <div key={index} className="flex items-center text-sm mb-1">
                              <FiPaperclip className="mr-1" size={14} />
                              {typeof anexo === 'string' ? anexo : anexo.name}
                            </div>
                          ))}
                        </div>
                      ) 
                      : 'Clique aqui para editar'}
                  </div>
                )}
              </div>
              
              {/* Observações */}
              <div className="mb-5">
                <div className="flex items-center mb-1">
                  <FiMessageSquare className="inline mr-2" size={16} />
                  <label className="text-sm font-medium text-gray-700">Observações:</label>
                </div>
                {editField === 'observacoes' ? (
                  <>
                    <Input
                      name="observacoes"
                      value={tempValue}
                      onChange={handleChange}
                      className="mb-2"
                    />
                    <div className="flex gap-2">
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={() => handleFieldSave('observacoes')}
                      >
                        Salvar
                      </Button>
                      <Button variant="secondary" size="sm" onClick={handleFieldCancel}>
                        Cancelar
                      </Button>
                    </div>
                  </>
                ) : (
                  <div
                    className="font-normal mt-2 text-sm cursor-pointer text-gray-400 transition-colors duration-300 hover:text-gray-500"
                    onClick={() => handleFieldClick('observacoes')}
                  >
                    {formData.observacoes || 'Clique aqui para editar'}
                  </div>
                )}
              </div>
            </div>
            
            <div className="mt-8">
              <h3 className="font-semibold mb-4">Detalhes Adicionais</h3>
              
              <Accordion
                sections={accordionSections}
                onToggleSection={handleToggleSection}
                emptyStateMessage="Nenhum item configurado"
              />
            </div>
          </div>
        </div>

        <div className="w-1/3 border-l overflow-y-auto p-2">
          <div className="flex items-center mb-4">
            <h3 className="font-semibold">Histórico das Fases</h3>
          </div>

          <Accordion
            sections={fases.map((fase, index) => ({
              id: `fase-${index}`,
              title: fase,
              icon: (
                <FiMinimize className='w-4 h-4 text-gray-500'/>
              ),
              count: 1,
              expanded: fasesExpanded[index],
              content: (
                <div className="text-sm text-gray-600 space-y-2 p-2">
                  <p>Data de mudança: 10/07/2025</p>
                  <p>Responsável: Ana Célia</p>
                  <p>Observações: Sem observações adicionais.</p>
                </div>
              )
            }))}
            onToggleSection={(sectionId) => {
              const index = parseInt(sectionId.replace('fase-', ''), 10);
              handleToggleFase(index);
            }}
          />
        </div>

      </div>
    </BaseForm>
  );
};

export default CardDetailForm;